/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  display: inline-block;
  vertical-align: middle;
  contain: content;
  cursor: pointer;
}

.link {
  text-decoration: none;
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  display: -webkit-inline-box;
  display: inline-flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
          flex-direction: row;
  flex-wrap: nowrap;
  -webkit-box-pack: start;
          justify-content: flex-start;
  align-content: stretch;
  -webkit-box-align: center;
          align-items: center;
  padding: calc(6rem/14) 0;
}
.link davinci-icon-ref,
.link davinci-icon {
  font-size: 1rem;
}
:host([inside-text]) .link {
  padding: 0;
}

:host([inverted]) .link {
  background-color: #323C43;
  background-color: var(--davinci-color-secondary, #323C43);
  color: #FFF;
  color: var(--davinci-color-text-on-secondary, #FFF);
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary, #FFF);
  padding: calc(6rem/14);
}

:host([inverted][inside-text]) .link {
  padding: 0 calc(6rem/14);
}

.link:visited davinci-icon-ref,
.link:visited davinci-icon {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
}
:host([inverted]) .link:visited davinci-icon-ref,
:host([inverted]) .link:visited davinci-icon {
  fill: #FFF;
  fill: var(--davinci-color-text-on-secondary, #FFF);
}

.link:visited .text {
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host([inverted]) .link:visited .text {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary, #FFF);
}

.link:active .text {
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
}
:host([inverted]) .link:active .text {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-light, #FFF);
}

:host([inverted]) .link:hover {
  background-color: #505F6B;
  background-color: var(--davinci-color-secondary-light, #505F6B);
}

.link:hover davinci-icon-ref,
.link:hover davinci-icon {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
}
.link:hover .text {
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}
:host([inverted]) .link:hover .text {
  color: #FFF;
  color: var(--davinci-color-text-on-secondary-light, #FFF);
}

:host(:not([icon])) {
  -webkit-transform: translateY(calc(-2rem/14));
          transform: translateY(calc(-2rem/14));
}
:host(:not([icon])) davinci-icon {
  display: none;
}`;
export { style };
//# sourceMappingURL=Link.style.js.map